import DemoCard from '../DemoCard'
import { DemoSectionProps } from '../types'

const SinglePractice = ({ demoMode, triggerDemo }: DemoSectionProps ) => {
  const demos = [
    {
      demo: `practice${demoMode}Demo`,
      isReset: false,
      buttonText: `Main ${demoMode} Demo`,
      features: [
        'Run all demo scenarios',
      ]
    },
    {
      demo: 'practiceResetAll',
      isReset: true,
      buttonText: 'Reset All Data',
      features: [
        'Remove all data'
      ]
    }
  ]
  return (
    <DemoCard headerText='Single Practice Mode' demos={demos} triggerDemo={triggerDemo} />
  )
}

export default SinglePractice